// @flow

export const ADD_PRODUCT = 'ADD_PRODUCT';
export const ADD_RESOURCE = 'ADD_RESOURCE';

export const ADD_INVOICE = 'ADD_INVOICE';
export const SAVE_INVOICE = 'SAVE_INVOICE';
export const DELETE_INVOICE = 'DELETE_INVOICE';
export const PAY_INVOICE = 'PAY_INVOICE';

export const GET_TOTAL = 'GET_TOTAL';

export const GET_INVOICES = 'GET_INVOICES';

export const FIELD_ID = {
  QTY: 'qty',
  RATE: 'rate',
  DISCOUNT: 'discount',
  DISCOUNT_PERCENTAGE: 'discountPercentage',
  TAXABLE: 'taxable',
  SALES_TAX: 'salesTax',
  INVOICE_NUMBER: 'invoiceNumber'
};

export const errorKeys = Object.values(FIELD_ID);

export const errorsInvoice = errorKeys.reduce(
  (acc, key) => ({
    ...acc,
    [key]: false
  }),
  {}
);
